function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -1240.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Photoshop",
  transform: "translate(0.000000, 1212.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#302280",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.000000, 8.000000)",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0.206966993 C0.696918466,0.0887001398 1.6416276,0 2.91151157,0 C4.30531007,0 5.31195727,0.280865857 5.97782986,0.813030857 C6.59732575,1.30086371 7,2.08432785 7,3.01555388 C7,3.96161703 6.69027127,4.7302799 6.11726735,5.26240906 C5.3429263,5.98673978 4.16594944,6.34157617 2.81856605,6.34157617 C2.46238377,6.34157617 2.15265504,6.32673906 1.88937985,6.26760563 L1.88937985,10 L0,10 L0,0.206966993 Z M1.88937985,4.83370964 C2.13717052,4.90764434 2.43141474,4.92244562 2.81856605,4.92244562 C4.24337201,4.92244562 5.11062015,4.24244705 5.11062015,3.08945275 C5.11062015,1.98082643 4.30531007,1.40429345 2.98893414,1.40429345 C2.46234535,1.40429345 2.09067855,1.44866143 1.88934143,1.49299358 L1.88934143,4.83370964 L1.88937985,4.83370964 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.36129416,8.27429337 C7.75148612,8.51085008 8.51742114,8.77527667 9.15320852,8.77527667 C9.93359243,8.77527667 10.280366,8.52498747 10.280366,8.07964273 C10.280366,7.62036305 9.99131632,7.39774129 9.12427487,7.09154359 C7.75145027,6.64616512 7.18787153,5.92256006 7.18787153,5.11537905 C7.18787153,3.91849188 8.21388672,3 9.84686319,3 C10.6271754,3 11.306417,3.18091814 11.7254351,3.40357363 L11.3641409,4.60042706 C11.0751271,4.43344387 10.4970995,4.21078838 9.87572513,4.21078838 C9.23990191,4.21078838 8.89305664,4.51695234 8.89305664,4.93442718 C8.89305664,5.36587071 9.22541715,5.56069005 10.1213923,5.88078896 C11.4075235,6.31223248 11.985587,6.93846161 12,7.94046196 C12,9.17912023 11.0028109,10 9.13868791,10 C8.28613121,10 7.52016034,9.80514692 7,9.52678537 L7.36129416,8.27429337 Z"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#7BBBFB",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))));

var SvgPhotoshop = function SvgPhotoshop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoshop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photoshop.92d25212.svg";
export { ForwardRef as ReactComponent };